
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_cauxy_94",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_cauxy_1",
  "refresh": "awsui_refresh_qwoo0_cauxy_115",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_cauxy_1",
  "root": "awsui_root_qwoo0_cauxy_144",
  "interior": "awsui_interior_qwoo0_cauxy_156",
  "dropdown": "awsui_dropdown_qwoo0_cauxy_94",
  "use-portal": "awsui_use-portal_qwoo0_cauxy_167",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_cauxy_212",
  "with-limited-width": "awsui_with-limited-width_qwoo0_cauxy_216",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_cauxy_219",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_cauxy_222",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_cauxy_225",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_cauxy_228",
  "open": "awsui_open_qwoo0_cauxy_235",
  "nowrap": "awsui_nowrap_qwoo0_cauxy_244",
  "is-empty": "awsui_is-empty_qwoo0_cauxy_248",
  "dropdown-content": "awsui_dropdown-content_qwoo0_cauxy_94",
  "ie11-wrapper": "awsui_ie11-wrapper_qwoo0_cauxy_258",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_cauxy_262"
};
  